import originalMedia from "./media.json";

import MediaSizes from "./media-sizes";

import ImplantMedia from "./implantology/media-implants";
import AllOn4Media from "./implantology/media-allon4";
import SinusLiftMedia from "./implantology/media-sinus-lift";
import BoneGraftMedia from "./implantology/media-bone-graft";
import ToothSurgeryMedia from "./oral-surgery/media-tooth-surgeries";
import GumSurgeryMedia from "./oral-surgery/media-gum-surgery";
import PerioDiseasesMedia from "./oral-surgery/media-periodontal-diseases";
import PerioMedia from "./oral-surgery/media-periodontics";
import PostMedia from "./conservative/media-post";
import FillingMedia from "./conservative/media-filling";
import InlayOnlayMedia from "./conservative/media-inlay-onlay";
import CrownMedia from "./prosthodontics/media-crown";
import VeneerMedia from "./prosthodontics/media-veneer";
import BridgeMedia from "./prosthodontics/media-bridge";
import DenturesMedia from "./prosthodontics/media-dentures";
import RootCanalMedia from "./conservative/media-root-canal";
import TemporaryBridgeMedia from "./prosthodontics/media-temporary-bridge";
import ComparisonsMedia from "./prosthodontics/media-comparisons"
import BitingDisorderMedia from "./orthodontics/media-biting-disorder";
import BracesMedia from "./orthodontics/media-braces";
import OrthognathicMedia from "./orthodontics/media-orthognathic-surgery";
import PalatalExpMedia from "./orthodontics/media-palatal-expansion";
import TeethWhiteningMedia from "./general/media-teeth-whitening";
import DentalProblemsMedia from "./general/media-dental-problems";
import ToothAnatomyMedia from "./general/media-tooth-anatomy";
import UnknownMedia from "./media-unknown";

// const items = originalMedia;

const items = [
    ...ToothAnatomyMedia,
    ...TeethWhiteningMedia,
    ...DentalProblemsMedia,
    ...BitingDisorderMedia,
    ...BracesMedia,
    ...OrthognathicMedia,
    ...PalatalExpMedia,
    ...TemporaryBridgeMedia,
    ...ComparisonsMedia,
    ...ImplantMedia,
    ...AllOn4Media,
    ...SinusLiftMedia,
    ...BoneGraftMedia,
    ...ToothSurgeryMedia,
    ...GumSurgeryMedia,
    ...PerioDiseasesMedia,
    ...PerioMedia,
    ...PostMedia,
    ...FillingMedia,
    ...InlayOnlayMedia,
    ...CrownMedia,
    ...VeneerMedia,
    ...BridgeMedia,
    ...DenturesMedia,
    ...RootCanalMedia,
    ...UnknownMedia,
];

items.forEach(i => {
   if (MediaSizes.hasOwnProperty(i.src)) i.width = MediaSizes[i.src][0];
   if (MediaSizes.hasOwnProperty(i.src)) i.height = MediaSizes[i.src][1];
});

function getImageSize(item) {
    const baseUrl = "https://cdn.denticalc.com/photos/";
    const img = new Image();
    img.onload = function () {
        item.width = this.width;
        item.height = this.height;
    }
    img.src = baseUrl + item.src.replace(".jpg", "_full_guetzli.jpg");
}

export default items;
